var _path, _rect, _rect2, _path2, _path3, _path4, _g, _rect3, _ellipse, _ellipse2, _rect4, _path5, _g2, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronicBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 191,
    viewBox: "0 0 170 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2968 100.69C12.4876 98.8643 14.8232 97.7225 17.3671 97.7225H152.633C155.177 97.7225 157.512 98.8643 158.703 100.69L167.529 114.222C169.044 116.544 166.971 119.341 163.735 119.341H6.26463C3.02878 119.341 0.955955 116.544 2.47064 114.222L11.2968 100.69Z",
    fill: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151.3,
    y: 186.273,
    width: 17.5879,
    height: 4.12931,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.96533,
    y: 185.641,
    width: 17.5879,
    height: 4.12931,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96533 146.319C1.96533 130.334 14.9238 117.376 30.9089 117.376H140.074C156.059 117.376 169.017 130.334 169.017 146.319V187.145H1.96533V146.319Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 121.128C0 115.799 4.3195 111.48 9.64787 111.48H160.352C165.68 111.48 170 115.799 170 121.128V185.179H0V121.128Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.364 168.409C149.364 173.738 145.045 178.057 139.716 178.057L29.3011 178.057C23.9727 178.057 19.6532 173.737 19.6532 168.409L19.6532 119.277L149.364 119.278L149.364 168.409Z",
    fill: "#CCD8E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_122323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.416 122.289H22.6012V153.891H146.416V122.289Z",
    fill: "#173E50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.7557 122.289L34.1786 153.891H72.6149L132.587 122.289H93.7557Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.079 122.289L75.986 153.891H80.1777L139.662 122.289H135.079Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.783 122.289H23.8875C23.1771 122.289 22.6012 122.865 22.6012 123.575V154.246C22.6012 154.957 23.1771 155.533 23.8875 155.533H147.783C148.493 155.533 149.069 154.957 149.069 154.246V123.575C149.069 122.865 148.493 122.289 147.783 122.289Z",
    stroke: "#031D29",
    strokeWidth: 2.57277,
    strokeMiterlimit: 10
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.1409,
    y: 102.212,
    width: 34.8025,
    height: 6.32038,
    fill: "#333333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2258,
    cy: 95.8921,
    rx: 62.6445,
    ry: 11.3767,
    fill: "#838383"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5422,
    cy: 93.9958,
    rx: 63.5937,
    ry: 12.0087,
    fill: "#5C5C5C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 157.211,
    width: 39.8439,
    height: 17.6747,
    rx: 2.25117,
    fill: "#A41034",
    stroke: "#C87085",
    strokeWidth: 1.28638
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_490_122323",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 156,
    width: 43,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.02 156.568V161.07V183.582H69.3579V175.863H64.8555L69.3579 171.361V161.07H101.517L106.02 156.568Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_490_122323)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 157.211,
    width: 39.8439,
    height: 17.6747,
    rx: 2.25117,
    stroke: "#830D2A",
    strokeWidth: 1.28638
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3953 169.589V168.535L79.1957 164.627H76.5573V163.465H80.8706V164.51L78.0701 168.427H80.9426V169.589H76.3953ZM83.7832 169.697C82.3604 169.697 81.6401 169.021 81.6401 167.698V166.779C81.6401 165.473 82.3604 164.78 83.7291 164.78C85.1069 164.78 85.8272 165.491 85.8272 166.797V167.653H82.9727V167.743C82.9727 168.355 83.2159 168.652 83.7922 168.652C84.2424 168.652 84.5035 168.472 84.5306 168.148H85.8002C85.7462 169.165 85.0528 169.697 83.7832 169.697ZM82.9727 166.716H84.5666C84.5666 166.086 84.3325 165.825 83.7742 165.825C83.2069 165.825 82.9727 166.086 82.9727 166.716ZM86.7883 169.589V164.888H87.9229L87.977 165.762C88.1571 165.095 88.5262 164.798 89.1746 164.798H89.5258V166.041H89.2736C88.5803 166.041 88.2471 166.302 88.121 166.959V169.589H86.7883ZM92.1457 169.697C90.723 169.697 90.0116 169.021 90.0116 167.671V166.806C90.0116 165.455 90.723 164.78 92.1457 164.78C93.5684 164.78 94.2798 165.455 94.2798 166.806V167.671C94.2798 169.021 93.5684 169.697 92.1457 169.697ZM92.1457 168.616C92.713 168.616 92.9471 168.328 92.9471 167.644V166.833C92.9471 166.149 92.713 165.861 92.1457 165.861C91.5784 165.861 91.3443 166.149 91.3443 166.833V167.644C91.3443 168.328 91.5784 168.616 92.1457 168.616Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5493 143.185C64.2029 143.185 62.9371 141.966 62.9371 139.697V135.807C62.9371 133.537 64.2029 132.318 66.5493 132.318C68.8957 132.318 70.1615 133.537 70.1615 135.807V139.697C70.1615 141.966 68.8957 143.185 66.5493 143.185ZM66.5493 141.95C68.0621 141.95 68.803 141.178 68.803 139.604V135.899C68.803 134.325 68.0621 133.553 66.5493 133.553C65.0365 133.553 64.2956 134.325 64.2956 135.899V139.604C64.2956 141.178 65.0365 141.95 66.5493 141.95ZM72.5474 143V141.425H74.1219V143H72.5474ZM80.1317 143.185C77.7853 143.185 76.5195 141.966 76.5195 139.697V135.807C76.5195 133.537 77.7853 132.318 80.1317 132.318C82.478 132.318 83.7438 133.537 83.7438 135.807V139.697C83.7438 141.966 82.478 143.185 80.1317 143.185ZM80.1317 141.95C81.6445 141.95 82.3854 141.178 82.3854 139.604V135.899C82.3854 134.325 81.6445 133.553 80.1317 133.553C78.6189 133.553 77.8779 134.325 77.8779 135.899V139.604C77.8779 141.178 78.6189 141.95 80.1317 141.95ZM89.4178 143.185C87.0714 143.185 85.8056 141.966 85.8056 139.697V135.807C85.8056 133.537 87.0714 132.318 89.4178 132.318C91.7641 132.318 93.0299 133.537 93.0299 135.807V139.697C93.0299 141.966 91.7641 143.185 89.4178 143.185ZM89.4178 141.95C90.9305 141.95 91.6715 141.178 91.6715 139.604V135.899C91.6715 134.325 90.9305 133.553 89.4178 133.553C87.905 133.553 87.164 134.325 87.164 135.899V139.604C87.164 141.178 87.905 141.95 89.4178 141.95ZM102.419 145.995C100.397 145.995 99.2854 145.161 99.1773 143.525H100.443C100.52 144.451 101.277 144.822 102.388 144.822C103.808 144.822 104.457 144.219 104.457 142.83V141.518C103.808 142.352 103.006 142.738 101.94 142.738C100.088 142.738 99.0075 141.595 99.0075 139.419V138.168C99.0075 135.992 100.088 134.849 101.94 134.849C103.083 134.849 103.932 135.297 104.596 136.27L104.657 135.035H105.815V142.83C105.815 144.945 104.688 145.995 102.419 145.995ZM102.11 141.549C103.114 141.549 103.932 140.901 104.457 139.774V137.813C103.932 136.686 103.114 136.038 102.11 136.038C101.014 136.038 100.366 136.794 100.366 138.215V139.372C100.366 140.793 101.014 141.549 102.11 141.549Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_122323"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.6012,
    y: 122.289,
    width: 123.815,
    height: 31.6019,
    rx: 1.28638,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicBalance);
export default __webpack_public_path__ + "static/media/electronic_balance.dd832cfe5cb2dbae300938fc80c73cd5.svg";
export { ForwardRef as ReactComponent };